import { z } from "zod";

export const adminSearchSchema = z.object({
  panel: z
    .enum([
      "users",
      "categories",
      "attributes",
      "tags",
      "core-signal-dashboard",
      "core-signal-companies",
      "core-signal-configuration",
      "job-postings",
    ])
    .default("users"),
  season: z.string().optional(),
  round: z.string().optional(),
  session: z.string().optional(),
  // Companies panel sorting
  companiesSortBy: z.string().optional(),
  companiesSortDirection: z.enum(["asc", "desc"]).optional(),
  // Configuration panel sorting
  configSortBy: z.string().optional(),
  configSortDirection: z.enum(["asc", "desc"]).optional(),
  // Dashboard panel sorting
  dashboardSortBy: z.string().optional(),
  dashboardSortDirection: z.enum(["asc", "desc"]).optional(),
  // Users panel sorting
  usersSortBy: z.string().optional(),
  usersSortDirection: z.enum(["asc", "desc"]).optional(),
  // Categories panel sorting
  categoriesSortBy: z.string().optional(),
  categoriesSortDirection: z.enum(["asc", "desc"]).optional(),
  // Attributes panel sorting
  attributesSortBy: z.string().optional(),
  attributesSortDirection: z.enum(["asc", "desc"]).optional(),
  // Tags panel sorting
  tagsSortBy: z.string().optional(),
  tagsSortDirection: z.enum(["asc", "desc"]).optional(),
});

export type AdminSearchParams = z.infer<typeof adminSearchSchema>;
